import * as React from 'react';
import type { ExtendedSubjectProps } from '../../StudyModelGrid';
import { HtmlDiv } from '~/Partials/Controls/HtmlDiv';
import { List } from '~/Partials/List/List';

export interface StudyModelGridHiddenTabContentProps {
    year: number;
    allSubjects: ExtendedSubjectProps[];
}

export const StudyModelGridHiddenTabContent: React.FC<StudyModelGridHiddenTabContentProps> = React.memo(props => {
    const { year, allSubjects } = props;

    const subjectsForYear = allSubjects.filter(subject => subject.year === year);

    return (
        <List
            items={subjectsForYear}
            renderItem={subject => (
                <li key={subject.code}>
                    <span>{subject.code}</span>
                    <span>{subject.name}</span>
                    <HtmlDiv html={subject.description} />
                </li>
            )}
        />
    );
});
